import React from "react";
import classNames from "classnames";

import CoinSvg from "@components/icons/coin-svg";

import { numberWithSpaces } from "@helpers/helpers";

type PropsTypeCoins = {
  coins: number;
  currentCoins?: number;
  classNameProps?: string;
  classNameSpanProps?: string;
  withSpace?: boolean;
};

function Coins({
  coins,
  currentCoins,
  classNameProps,
  classNameSpanProps,
  withSpace = true,
}: PropsTypeCoins) {
  const coinsText = withSpace ? numberWithSpaces(coins) : coins;
  return (
    // eslint-disable-next-line
    <>
      <div className={classNames("text-center", classNameProps)}>
        <span
          className={classNames(
            "dark:bg-yellow-dark-light inline-flex items-center rounded-xxl bg-yellow-light p-1 pr-2 font-bold text-txt-primary",
            classNameSpanProps,
          )}
        >
          <CoinSvg width={23} height={23} classNameProps='mr-1' />
          {coinsText}
          {currentCoins ? ` + ${numberWithSpaces(currentCoins)}` : null}
        </span>
      </div>
    </>
  );
}

export default Coins;
